import React from 'react';
import { Form, Switch, Typography, theme } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

/**
 * Inline "Create a reminder" switch bound to the `createReminder` form field,
 * rendered as a bordered row so it reads as one option rather than a loose label.
 */
export const ReminderToggle: React.FC = () => {
  const { token } = theme.useToken();
  const { t } = useTranslation('manage');

  return (
    <label
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: token.marginSM,
        padding: `${token.paddingXS}px ${token.paddingSM}px`,
        borderRadius: token.borderRadiusLG,
        border: `1px solid ${token.colorBorderSecondary}`,
        background: token.colorFillQuaternary,
        cursor: 'pointer'
      }}
    >
      <Typography.Text style={{ display: 'inline-flex', alignItems: 'center', gap: token.marginXS }}>
        <BellOutlined style={{ color: token.colorTextTertiary }} />
        {t('appointmentComponents.create.reminder.label')}
      </Typography.Text>
      <Form.Item name="createReminder" valuePropName="checked" noStyle>
        <Switch size="small" />
      </Form.Item>
    </label>
  );
};
